import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../ui/dropdown-menu';

import clsx from 'clsx';

export type DropdownItem =
  | { label: string; slug: string; onClick?: never }
  | { label: string; slug?: never; onClick: () => void };

export interface DropdownProps {
  label?: string;
  items: (DropdownItem | null)[];
  align?: 'center' | 'start' | 'end' | undefined;
  icon?: string;
  variant?: 'button' | 'dropdown';
}

export const Dropdown = ({
  label,
  items,
  align = 'center',
  icon = 'expand_more',
  variant = 'dropdown',
}: DropdownProps) => {
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          className={clsx(
            'flex items-center gap-2 cursor-pointer group',
            variant === 'button' &&
              'border-2 border-grey-400 hover:bg-blue-100 rounded-lg inline-flex justify-center w-full px-2 py-2 font-medium transition-colors   dark:text-blue-100 dark:hover:text-blue-300 hover:text-grey-800 text-grey-1000 focus:outline-none focus-visible:ring-2 focus-visible:blue-500 focus-visible:dark:ring-blue-700 focus-visible:ring-opacity-75'
          )}
        >
          {label && <span className="group-hover:underline">{label}</span>}
          <span className="material-symbols-outlined">{icon}</span>
        </DropdownMenuTrigger>
        <DropdownMenuContent align={align} className="bg-grey-200 border-grey-400 dark:bg-blue-1000 dark:border-grey-700">
          {items?.map((item) => {
            if (!item) return null;

            if (item.onClick) {
              return (
                <DropdownMenuItem
                  className="px-5 text-base hover:!bg-blue-200 w-full dark:hover:!bg-blue-900"
                  key={item.label}
                  asChild
                >
                  <button onClick={item.onClick}>{item.label}</button>
                </DropdownMenuItem>
              );
            }

            if (item.slug) {
              return (
                <DropdownMenuItem
                  key={item.label}
                  className="px-5 text-base hover:!bg-blue-200 dark:hover:!bg-blue-900"
                  asChild
                >
                  <a href={item.slug}>{item.label}</a>
                </DropdownMenuItem>
              );
            }
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
